import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import useAuth from "@/hooks/useAuth";
import { fetchSmsUsageHistory } from "@/redux/slice/cost-management/cost-management-slice";
import { SmsUsageHistoryTable } from "@/components/backoffice/cost-management/sms-usage-history-table";
import { getActiveRestaurantId } from "@/lib/idProvider";

export function SmsUsageHistory() {
  const { user } = useAuth();
  const dispatch = useDispatch();

  const { smsUsageHistory, smsLoading } = useSelector(
    (state) => state.costManagement,
  );

  const restaurantId =
    user?.restaurant_id || getActiveRestaurantId() || 1;

  useEffect(() => {
    dispatch(
      fetchSmsUsageHistory({
        restaurant_id: restaurantId,
      }),
    );
  }, [dispatch, restaurantId]);

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "SMS Using History" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Cost Management", path: "" },
        {
          name: "SMS Using History",
          path: "/backoffice/cost-management/sms-usage-history",
        },
      ]}
    >
      <div className="container max-w-7xl mx-auto px-4 py-5 flex flex-col gap-6">
        {/* Main Card */}
        <div className="bg-[#181a20] border border-[#262a2e] rounded-xl p-5 md:p-6 shadow-sm">
          {/* Card Header */}
          <div className="mb-5 flex flex-col gap-1">
            <h2 className="text-base md:text-lg font-semibold text-cwhite">
              Monthly SMS Using History
            </h2>
            <p className="text-xs md:text-sm text-gray-400">
              Month-by-month SMS consumption count & billing summary
            </p>
          </div>

          {/* Table */}
          <SmsUsageHistoryTable
            data={smsUsageHistory}
            loading={smsLoading}
          />
        </div>
      </div>
    </Layout2>
  );
}

export default SmsUsageHistory;
